<p><strong><%- address.name %></strong></p>
<% if (!address.virtual) { %>
  <p><%- address.street_address %></p>
  <% if (address.city || address.state || address.zip_code) { %>
    <p><%- [ address.city, address.state + " " + address.zip_code ].join(", ") %></p>
  <% } %>
<% } %>
